<template>
  <div class="work-in-progress">
    <div class="work-in-progress">
      <div class="center">
        <div class="content">
          Ci stiamo rifacendo il look..<br/>
          Questa pagina è in manuntenzione e sarà presto disponibile!<br/>
          Per qualsiasi domanda contattaci ai numeri presenti nella pagina
          <router-link to="/contacts">contatti</router-link>.
          <div class="clear_big"/>
          <img
            src="@/assets/images/common/work-in-progress.png"
            width="80"
            height="80"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'work-in-progress'
}
</script>
